import { Routes } from '@angular/router';

import { AuthService } from '../../auth/auth.service';

import { VoiceProfileComponent } from './voice-profile.component';

export const VoiceProfileRoutes: Routes = [
    {
        path: 'local-call/recognition/voice-profile',
        canActivate: [AuthService],
        component: VoiceProfileComponent,
    },
];
